export default {
  taxReturnsPages: {
    common: {
      actions: "Actions",
      all: "All",
      countryFilter: "Country filter",
      deleteConfirm: "Do you want to delete {{name}} for the period {{period}}?",
      downloadFailed: "Download failed",
      downloadReport: "Download report",
      enterMessage: "Enter message",
      error: "Error",
      errorOccurred: "An error occurred",
      failedToSaveReturn: "Failed to save return. Please try again.",
      message: "Message",
      ok: "Ok",
      paymentRequestFailed: "Payment request failed",
      reasonN: "Reason {{reason}}",
      returnWasCreated: "{{type}} was created",
      returnWasSaved: "{{type}} was saved",
      save: "Save",
      select: "Select",
      serverError: "Server error",
      somethingWentWrong: "Something went wrong...",
      statusUpdateError: "An error occurred while updating status",
      success: "Success",
      type: "Type",
      vatReturnCreated: "VAT return was created",
      vatReturnRow: "VAT return ROW",
    },
    vatReturns: {
      emptyDescription: "Add VAT returns to see data",
      emptyButton: "Add VAT returns",
    },
    periodicity: {
      quarterly: "Quarterly",
      monthly: "Monthly",
      period: "Period",
      biAnnual: "Bi-annual",
      biMonthly: "Bi-monthly",
      yearly: "Yearly",
    },
    payment: {
      noPaymentData: "No payment data found.",
      checkingStatus: "Checking subscription status... ({{attempt}}/{{total}})",
      unexpectedError:
        "An unexpected error occurred. Please try again later or contact support if the issue persists",
      activated: "Your subscription has been activated. Thank you for your payment!",
      failed:
        "We couldn't process your payment. Please check your card details or try a different payment method",
      cancelled: "Payment was cancelled. You can try again when ready.",
      processing: "Payment is still processing. Please wait...",
    },
    titles: {
      salesListFor: "Sales List for {{period}} for {{country}}",
      pstReturnFor: "PST return for {{country}} / {{state}} for {{period}}",
      vatReturnFor: "VAT Return for {{period}} for {{country}}",
      returnFor: "{{type}} for {{period}} for {{country}}",
      crossBorderDigital: "Cross-border digital services",
      nonUnionOss: "non-union OSS VAT Return",
      ioss: "IOSS VAT Return",
      unionOss: "Union OSS VAT Return",
    },
    previews: {
      revenueWithCurrency: "Revenue ({{currency}})",
      amountWithCurrency: "Amount ({{currency}})",
      vatRate: "VAT rate",
      vat: "VAT",
      importLowValueGoods: "Import of Low value goods",
      vatDue: "VAT due",
      salesOfServices: "Sales of services",
      salesOfServicesCorrected: "Sales of services corrected",
      salesOfServicesDeemed: "Sales of services (deemed)",
      salesOfGoods: "Sales of goods",
      salesOfGoodsFrom: "Sales of goods from",
      salesOfGoodsRC: "Sales of goods (RC)",
      salesOfGoodsOther: "Sales of goods (other)",
      salesOfGoodsRCCorrected: "Sales of goods corrected (RC)",
      salesOfGoodsOtherCorrected: "Sales of goods corrected (other)",
      salesOfGoodsRCDeemed: "Sales of goods (RC deemed)",
      salesOfGoodsOtherDeemed: "Sales of goods (other deemed)",
      salesOfDomestic: "Sales of domestic",
      salesDomesticByOmp: "Sales domestic by OMP",
      total: "Total",
      totalDue: "Total due",
      totalRefund: "Total refund",
    },
    goods: {
      supplierVatNo: "Supplier VAT No",
      valueOfSupplies: "Value of supplies",
      vatRate: "VAT Rate",
      sellerName: "Seller name",
      customerName: "Customer name",
      invoiceDate: "Invoice date",
      invoiceNumber: "Invoice number",
      taxableAmount: "Taxable amount",
      pstAmount: "PST Amount",
      exempted: "Exempted",
      emirate: "Emirate",
      state: "State",
      revenue: "Revenue",
      vatPaymentsForYear: "VAT payments paid for year {{year}}",
      importOutsideCanada: "Did you import your goods from outside Canada?",
      importOutsideUae: "Did you import your goods from outside the United Arab Emirates?",
      importVatPaidAtCustoms: "Import VAT paid at customs",
      vatPaidAtCustomsHint: "VAT paid at customs. If you deferred your VAT please fill below.",
      deferredImportVat: "Deferred import VAT",
      intrinsicValueStandard: "Intrinsic value of imported goods standard rate",
      intrinsicValueReduced: "Intrinsic value of imported goods reduced rate",
      mergeWarningTransactions: "Merge warning transactions with same vat number?",
      checkVatNumbers: "Check Vat Numbers",
      intraCommunitySupplies: "Intra community supplies",
      bankName: "Name of bank",
      accountNumber: "Account number",
      bankAccountHolder: "Bank account holder",
      bankInfo: "Bank info",
      vatPercent: "VAT percent",
      newRecordWithTitle: "{{title}}: new record",
      newRecord: "New record",
      withoutVat: "Without VAT",
      editTransactionSum: "Please edit sum for the transaction {{country}} {{vat}}",
      payments: "Payments",
    },
    oss: {
      departureCountry: "Departure country",
      arrivalCountry: "Arrival country",
      quarter: "Quarter",
      salesOfGoodsFromCountry: "Sales of goods from {{country}}",
      salesOfGoodsFromCountryCorrected: "Sales of goods from {{country}} corrected",
      salesOfGoodsFromCountryDeemed: "Sales of goods from {{country}} deemed",
      salesOfGoodsOtherCountries: "Sales of goods from other countries",
      salesOfGoodsOtherCountriesCorrected: "Sales of goods from other countries corrected",
      salesOfGoodsOtherCountriesDeemed: "Sales of goods from other countries deemed",
      salesOfServicesDeemed: "Sales of services deemed",
      summary: "Summary",
      insufficientAddons: "Insufficient addons or revenue",
      insufficientAddonsDescription: "You don't have enough addons or revenue. Please try again.",
    },
    salesTax: {
      state: "State",
      taxAmount: "TAX amount",
      stateFilter: "State filter",
      emptyDescription: "Add transactions to see data",
      emptyButton: "Add transactions",
      detailsTitle: "{{name}} details",
      filesAvailable: "Files available to download",
      autoSubmit: "Auto-submit",
      autoSubmitTitle: "Auto-submit {{name}} for the amount {{amount}} $",
      taxDue: "Tax Due",
      prepaymentTaxDue: "Prepayment Tax due",
      grossSales: "Gross Sales",
      salesTax: "Sales Tax",
      calculationRule: "Calculation Rule",
      calculationRuleValue: "Current-period 90% of liability",
      outputSalesTax: "Output Sales Tax",
      prepayment: "Prepayment",
      paymentDetails: "Payment details",
      salesTaxReport: "Sales Tax Report",
      salesTaxPrepaymentReport: "Sales Tax Prepayment report",
      permitNumber: "Sales tax permit number",
      taxReturnSaved: "TAX return was saved",
      savedDescription:
        "You successfully saved your Sales Tax Return for {{state}} for {{period}} {{year}}. It is available to download.",
      submittedDescription:
        "You successfully submitted your Sales Tax Return for {{state}} for {{period}} {{year}}. It is available to download.",
      salesTaxReturnFor: "Sales Tax Return for {{state}} for {{period}}",
      stepTitle: "{{type}} for {{period}} {{year}} {{state}}",
      optionalStep: "* This step is optional and you can skip it",
      bankRoutingNumber: "Bank routing number",
      mustBe9Characters: "Must be 9 characters",
      accountType: "Account type",
      businessChecking: "Business Checking",
      businessSavings: "Business Savings",
      accountHolder: "Account holder",
      downloadForms: "Download forms",
      firstPrepayment: "1st Prepayment",
      secondPrepayment: "2nd Prepayment",
      totalPrepayment: "Total Prepayment",
      enterNumber: "Enter number",
      prepaymentData: "Prepayment Data",
      tax: "Tax",
      taxablePurchases: "Taxable purchases",
      exemptSales: "Exempt Sales & Other Deductions (non-taxable sales)",
      salesReducedRate: "Sales reduced rate",
      totalTaxableStateSales: "Total Taxable State Sales and Use",
      localTaxableSales: "Local Taxable Sales",
      combinedSalesTax: "Combined sales tax",
      stateTax: "State Tax",
      regionalTax: "Regional Tax (county)",
      localTax: "Local Tax (city)",
      districtTax: "District Tax/special",
      totalStateRegionalLocalTax: "Total State, Regional, Local and district Tax",
      taxWithheldByMarketplace: "Tax withhold by Marketplace facilitator",
      lessLawfulDeductions: "Less lawful deductions (Florida)",
      metroAreaTax: "Metro area tax",
    },
    reports: {
      deleteReport: "Delete report",
      deleteReportConfirm: "Do you want to delete the report?",
      deleteDac7Confirm: "Do you want to delete the report for {{name}} for {{year}}?",
      paidSubscriptionRequired:
        "This functionality is not available because a paid subscription is required.",
      auditReady: "Tax audit report for {{country}} from {{from}} to {{to}} was successfully generated",
      auditNoData: "Tax audit report for {{country}} from {{from}} to {{to}} does not contain data",
      periodNotPaid: "The period from {{from}} to {{to}} is not included in the subscription",
      dateRequest: "Date request",
      merchantId: "Merchant id",
      marketplaceReports: "Marketplace reports",
      marketplaceReportType: "Type Marketplace reports",
      dac7Reporting: "DAC7 reporting",
      dac7Immovable: "DAC7 immovable property reporting",
      reporting1099K: "1099-K reporting",
      fill1099K: "Fill 1099-K reporting",
      fillDac7Immovable: "Fill DAC7 immovable property reporting",
      fillReport: "Fill report",
      year: "Year",
      biAnnual1: "bi-annual (Jan-Jun)",
      biAnnual2: "bi-annual (Jul-Dec)",
      fillingDate: "Filling date",
      noDate: "No date",
      noCountry: "No country",
      loadingReports: "Loading reports",
      changeStatus: "Change status",
      statuses: {
        new: "New",
        pending: "Pending",
        submitted: "Submitted",
        declined: "Declined",
      },
    },
    calendar: {
      createNewReport: "Create new report",
      create: "Create",
      selectBusiness: "Select business",
      selectDate: "Select date",
      selectReportType: "Select report type",
      selectType: "Select type",
      fillReturn: "Fill Return",
      viewReturn: "View Return",
      frequency: "Frequency",
      progress: "Progress",
      upcomingReports: "Upcoming reports",
      noReportsYet: "No reports yet",
      reportingTimeline: "Reporting timeline",
      previousDate: "Previous date with reports",
      nextDate: "Next date with reports",
      dates: "Dates",
      collapse: "Collapse",
      moreCount: "+{{count}} more",
      previousMonth: "Previous month",
      nextMonth: "Next month",
      loading: "Loading",
      filters: {
        title: "Filters",
        business: "Business",
        jurisdiction: "Jurisdiction",
        reportType: "Report type",
        status: "Status",
      },
      reportTypes: {
        vat: "VAT",
        salesList: "Sales list",
        oss: "OSS",
        ioss: "IOSS",
        salesTax: "Sales tax",
      },
      statuses: {
        overdue: "Overdue",
        dueSoon: "Due soon",
        upcoming: "Upcoming",
      },
      months: {
        jan: "January",
        feb: "February",
        mar: "March",
        apr: "April",
        may: "May",
        jun: "June",
        jul: "July",
        aug: "August",
        sep: "September",
        oct: "October",
        nov: "November",
        dec: "December",
      },
      monthsShort: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec",
      },
      weekdaysShort: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
      },
      weekdaysNarrow: {
        mon: "M",
        tue: "T",
        wed: "W",
        thu: "T",
        fri: "F",
        sat: "S",
        sun: "S",
      },
    },
    dac7: {
      commissions: "Commissions",
      returnEmailAddress: "Return email address",
      fillDac7Report: "Fill Dac7 Report",
      merchantInfoFilled: "successfully filled merchant info",
      removeRelevantActivity: "remove relevant activity",
      taxIdentificationNumber: "Tax identification number",
      legalEntity: "Legal entity",
      naturalPerson: "Natural person",
    },
    report1099: {
      preliminaryReport: "1099-K preliminary report",
      fill1099Return: "Fill 1099 Return",
      errorUploadingFile: "Error uploading file",
      submitDeclaration:
        "By clicking on the 'Submit' button, you agree to the following: When you submit this 1099 return information you are making a legal declaration that the information is true and complete. A false declaration can result in prosecution",
      address: "Address",
      grossAmount: "Gross amount of transactions",
      cardNotPresent: "Card Not Present transactions",
      merchantCategoryCode: "Merchant category code (relevant activity)",
      numberOfPaymentTransactions: "Number of payment transactions",
      federalIncomeTax: "Federal income tax withheld",
      stateIdNo: "State identification no",
      stateIncomeTax: "State income tax withheld",
    },
    orderReg: {
      registrationPrice: "Registration price",
      taxRepresentative: "Tax representative",
      intermediaryService: "Intermediary service",
      total: "Total",
    },
  },
};
